module.exports = __webpack_public_path__ + "static/media/read3.bf6bf8f2.svg";